module.exports = __webpack_public_path__ + "media/77.af1d661a.wav";